// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CoinList_wrapper__39oWa","boxone":"CoinList_boxone__3mkLY","boxtwo":"CoinList_boxtwo__46WN1"};